/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Fragment Payments API
 * REST API for Fragment payment operations
 * OpenAPI spec version: 1.0.0
 */

/**
 * Operation type - update an existing line item
 */
export type UpdateLineItemOperationOp = (typeof UpdateLineItemOperationOp)[keyof typeof UpdateLineItemOperationOp];

export const UpdateLineItemOperationOp = {
  update: 'update',
} as const;
